import { privateAxios } from "@/common/api/axios";
import { UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { EditEquipmentUsageValidationSchema } from "../schemas/editEquipmentUsage.schema";
import { unFormatUnknownUnit } from "@/common/utils/unFormatters";

interface useUpdateEquipmentUsageOptions {
  equipmentId: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void,
}

const useUpdateEquipmentUsage = ({ equipmentId, onSuccess, onError }: useUpdateEquipmentUsageOptions): UseMutationResult<void, Error, EditEquipmentUsageValidationSchema> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ value, reason, file }: EditEquipmentUsageValidationSchema) => {
      await privateAxios.postForm(`/equipments/${equipmentId}/last_usage_declaration`, {
        last_usage_declaration: {
          value: value ? unFormatUnknownUnit(value) : undefined,
          reason,
          file,
        }
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['equipment', equipmentId] });
      onSuccess?.();
    },
    onError
  });
};

export default useUpdateEquipmentUsage;
